import {SCREENING_QUESTION_TYPE_MULTISELECT, SCREENING_QUESTION_TYPE_VIDEO} from "../constants/ScreeningQuestions";
import {getItem, setItem} from "../helpers/LocalStorage";
import {nextTick, ref} from "vue";

export const useQuickApplyScreeningQuestions = () => {
  const LOCAL_STORAGE_KEY = "screening-answers";

  const initialSyncComplete = ref(false);

  const handlePushToLocalStorage = async (rawAnswers, opportunityUuid) => {
    if (!initialSyncComplete.value) return;

    let serializedAnswers = []; // Remove video files, they are too big to store in local storage

    for (let i = 0; i < rawAnswers.length; i++) {
      const answer = rawAnswers[i];

      switch (answer?.type) {
      case SCREENING_QUESTION_TYPE_VIDEO:
        serializedAnswers.push({
          question: answer?.question,
          type: answer?.type,
        });
        break;
      case SCREENING_QUESTION_TYPE_MULTISELECT:
        serializedAnswers.push({
          question: answer?.question,
          type: answer?.type,
          answer: answer?.answer || [],
        });
        break;
      default:
        serializedAnswers.push({
          question: answer?.question,
          type: answer?.type,
          answer: answer?.answer,
        });
        break;
      }
    }

    setItem(LOCAL_STORAGE_KEY, {
      uuid: opportunityUuid,
      list: serializedAnswers,
    }, 72);
  };

  const handleGetFromLocalStorage = async (opportunityUuid, screeningQuestions, getAnswer, setAnswer) => {
    const answers = getItem(LOCAL_STORAGE_KEY);

    if (
      !answers ||
      answers?.uuid !== opportunityUuid ||
      !answers.list ||
      answers.list.length !== screeningQuestions.length ||
      answers.list.some((answer, i) => !screeningQuestions[i].type.includes(answer?.type))
    ) {
      return initialSyncComplete.value = true;
    }

    for (let i = 0; i < answers.list.length; i++) {
      if (getAnswer(i)) continue;
      setAnswer(i, answers.list[i]);
    }

    await nextTick();

    initialSyncComplete.value = true;
  };

  return {
    initialSyncComplete,
    handlePushToLocalStorage,
    handleGetFromLocalStorage,
  };
};
